module.exports = __webpack_public_path__ + "media/images/padlet_logo_black-b637f7a60bd79c21c564054f17ac6b9b.svg";